import React from 'react';
import { Box, Typography, Paper, Stack, Chip } from '@mui/material';

const ActionVerbsDisplay = ({ data, loading, isLastResult }) => {
  return (
    <Box sx={{ mt: '3rem' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h5" gutterBottom sx={{ 
          color: 'text.primary', 
          mb: 0,
          fontSize: { xs: '1.25rem', sm: '1.5rem' }
        }}>
          Action Verbs {!isLastResult && '(Previous Analysis)'}
        </Typography>
      </Box>
      {data.characters.map((character, index) => (
        <Paper 
          key={index} 
          sx={{ 
            p: { xs: '0.75rem', sm: '1rem' }, 
            mb: '1rem', 
            backdropFilter: 'blur(5px)',
            backgroundColor: 'rgba(18, 18, 18, 0.4)',
            color: 'text.primary'
          }}
        >
          <Typography variant="h6" gutterBottom sx={{ 
            color: 'text.primary',
            fontSize: { xs: '1rem', sm: '1.25rem' }
          }}>
            {character.name}
          </Typography>
          <Box 
            sx={{ 
              display: 'flex',
              flexWrap: 'wrap',
              gap: { xs: '0.35rem', sm: '0.5rem' }
            }}
          >
            {character.actionVerbs.map((verb, verbIndex) => (
              <Chip
                key={verbIndex}
                label={verb}
                variant="outlined"
                size="small"
                sx={{ 
                  backdropFilter: 'blur(5px)',
                  backgroundColor: 'rgba(18, 18, 18, 0.4)',
                  color: 'text.primary',
                  borderColor: '#f94c57',
                  fontSize: { xs: '0.75rem', sm: '0.875rem' },
                  height: { xs: '24px', sm: '32px' },
                  '& .MuiChip-label': {
                    px: { xs: 1, sm: 1.5 }
                  },
                  '&:hover': {
                    backgroundColor: 'rgba(18, 18, 18, 0.6)',
                  }
                }}
              />
            ))}
          </Box>
        </Paper>
      ))}
    </Box>
  );
};

export default ActionVerbsDisplay;
